{
    "Accessibility Menu": "Meni Za Pristupačnost",
    "Reset settings": "Resetuj postavke",
    "Close": "Zatvori",
    "Content Adjustments": "Podešavanje Sadržaja",
    "Adjust Font Size": "Podešavanje Veličine Fonta",
    "Highlight Title": "Označi Naslove",
    "Highlight Links": "Označi Veze",
    "Readable Font": "Čitljiviji Font",
    "Color Adjustments": "Podešavanje Boja",
    "Dark Contrast": "Tamni Kontrast",
    "Light Contrast": "Svijetli Kontrast",
    "High Contrast": "Visoki Kontrast",
    "High Saturation": "Velika Zasićenost",
    "Low Saturation": "Niska Zasićenost",
    "Monochrome": "Jednobojni",
    "Protanopia": "Protanopija",
    "Deuteranopia": "Deuteranopija",
    "Tritanopia": "Tritanopija",
    "Visual & Navigation Aids": "Vizuelni i navigacijski pomagači",
    "Additional Tools": "Dodatni alati",
    "Reading Guide": "Vodič Za Čitanje",
    "Stop Animations": "Zaustavi Animacije",
    "Big Cursor": "Veliki Kursor",
    "Screen Reader": "Čitač ekrana",
    "Hide Images": "Sakrij slike",
    "Image Tooltips": "Saveti za slike",
    "Page Structure": "Struktura stranice",
    "Super Focus": "Super Focus",
    "Magnifier": "Uvećalo",
    "Increase Font Size": "Povećaj Veličinu Fonta",
    "Decrease Font Size": "Smanji Veličinu Fonta",
    "Letter Spacing": "Razmak Slova",
    "Line Height": "Visina Linije",
    "Font Weight": "Debljina Fonta",
    "Dyslexia Font": "Font Za Disleksičare",
    "Language": "Jezik",
    "Open Accessibility Menu": "Otvori Meni Za Pristupačnost",
    "Accessibility Profiles": "Profili pristupačnosti",
    "Seizure Safe Profile": "Bezbedan profil za epileptičare",
    "Stops animations and reduces color saturation.": "Zaustavlja animacije i smanjuje zasićenost boja.",
    "Blind Profile": "Profil za slepe",
    "Activates the screen reader for auditory navigation.": "Aktivira čitač ekrana za zvučnu navigaciju.",
    "Visually Impaired Profile": "Profil za slabovide",
    "Enhances contrast and readability for low vision.": "Poboljšava kontrast i čitljivost za slabovide.",
    "ADHD Friendly Profile": "Profil pogodan za ADHD",
    "Reduces distractions for better focus.": "Smanjuje ometanje za bolju koncentraciju.",
    "Cognitive & Learning Profile": "Kognitivni i edukativni profil",
    "Helpful tools for reading and comprehension.": "Korisni alati za čitanje i razumevanje.",
    "Motor Impaired Profile": "Profil za motoričke poteškoće",
    "Optimizes the site for keyboard-only navigation.": "Optimizuje sajt za navigaciju samo tastaturom.",
    "Headings": "Naslovi",
    "Landmarks": "Orijentiri",
    "Links": "Veze",
    "Focus element": "Fokusiraj element",
    "Visit link": "Posetiti vezu"
}
